import { CheckableGroupComponent } from "./chunk-74SYDCTI.js";
import { CheckboxField_default } from "./chunk-363LOYLC.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckboxGroup/CheckboxGroup.Field.tsx
import { forwardRef } from "react";
import clsx from "clsx";
import { jsx } from "react/jsx-runtime";
var CheckboxGroupField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      className
    } = _b,
    rest = __objRest(_b, ["className"]);
  return /* @__PURE__ */jsx(CheckableGroupComponent.Field, __spreadValues({
    as: CheckboxField_default,
    ref,
    className: clsx("pd:checkbox-group__field", className)
  }, rest));
});
var CheckboxGroup_Field_default = CheckboxGroupField;
export { CheckboxGroup_Field_default };